export default {
    title: "Verificação de endereço",
    header: "@:views.address.verified.title",
    message: "Obrigado por verificar seu endereço. Agora você pode escolher isso como endereço de entrega ao fazer um pedido.",
}